import * as Actions from "./_ActionTypes";
import * as Pre from "./_PreActionNames";
const _preActionName = Pre.ACCESS_CONTROL;

export function OpenDoor(deviceId = 0, deviceUId = null, accessToken) {
  return {
    type: _preActionName + Actions.OPEN_DOOR,
    accessToken,
    payload: { deviceId, deviceUId },
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}
export function PlaySoundAlarm(accessToken) {
  return {
    type: _preActionName + Actions.PLAY_SOUND_ALARM,
    accessToken,
    payload: {},
    socket: {
      send: false,
      keepSocket: true,
    },
  };
}
export function StopSoundAlarm(accessToken) {
  return {
    type: _preActionName + Actions.STOP_SOUND_ALARM,
    accessToken,
    payload: {},
    socket: {
      send: false,
      keepSocket: true,
    },
  };
}

export function RequestNotification(deviceId = 0, deviceUId = null, accessToken) {
  return {
    type: _preActionName + Actions.REQUEST_NOTIFICATION,
    accessToken,
    payload: { deviceId, deviceUId },
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

export function CloseCamera(processId, accessToken) {
  return {
    type: _preActionName + Actions.CLOSE_CAMERA,
    accessToken,
    payload: { processId },
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

export function ConfirmAcknowledgement(eventId, accessToken) {
  return {
    type: _preActionName + Actions.ACK_CONFIRM,
    accessToken,
    payload: { eventId },
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}
export function ToggleSystemLock(deviceId = 0, deviceUId = null, accessToken) {
  return {
    type: _preActionName + Actions.TOGGLE_SYSTEM_LOCK,
    accessToken,
    payload: { deviceId, deviceUId },
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}
